import { Component, ElementRef, OnInit } from '@angular/core';
import { UtilService } from '../../services/util.service';
import { LoaderService } from '../../services/loader.service';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../shared/services/base.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { CommunicationService } from '../../services/communication.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-archival-engine',
    templateUrl: './archival-engine.component.html',
    styleUrls: ['./archival-engine.component.scss'],
    standalone: false
})
export class ArchivalEngineComponent implements OnInit {
  currentData: any = { bannerJson: {}, complexSearch: { placeholder: 'Search With UHID' }, list: [], dropdownDataVal: "", imageInfo: [{ name: '', contentType: 'application/png' }], navigated: false, filterBlock: { default_open: true } };

  constructor(public utilService: UtilService, public loader: LoaderService, public http: HttpClient, public baseService: BaseService, private elementRef: ElementRef, public rolePermissionService: RolePermissionService, public communicationService: CommunicationService, public activatedRoute: ActivatedRoute) {
    this.baseService.setTitle('Archived Data');
  }

  ngOnInit(): void {
    this.currentData['queryParams'] = this.activatedRoute.snapshot.queryParams;
    this.setHeader();
    this.baseService.getResourceDef("archivalData", (resouceDef) => {
      if (resouceDef) {
        this.currentData.json = resouceDef;
        this.checkTabPermission(this.currentData.json.tabs);
        this.setFields(resouceDef.tabs[0]);//setting first tab as default
      }
    })

  }

  setHeader() {
    if (this.currentData['queryParams'].key != undefined && this.currentData['queryParams'].uhId != undefined) {
      this.currentData['navigated'] = true;
      this.communicationService.emitSidebar({ sidebar: false });
      this.communicationService.emitChange({ hideMenuIcon: true });
    }
  }

  checkTabPermission(tabs) {
    for (let crnTab of tabs) {
      if (crnTab['action_name'] != undefined) {
        let permission = this.rolePermissionService.checkAccessPermission(crnTab['action_name'], 'patient_journey', 'emr');
        let navPermission = true;
        if (this.currentData['navigated'] != undefined && this.currentData['navigated']) {
          if ((crnTab['action_name'] == this.currentData['queryParams'].key)) {
            navPermission = true;
          }
          else {
            navPermission = false;
          }
        }
        if (permission && navPermission) {
          crnTab['allowed'] = true;
        }
      }
      else
        crnTab['allowed'] = false;
    }
    tabs = tabs.filter(crntTab => crntTab['allowed'] != undefined && crntTab['allowed']);
    this.currentData.json.tabs = tabs;

  }

  setFields(resouce) {
    this.currentData['filterBlock'] = resouce.filter;
    this.currentData.fields = resouce.fields;
    this.currentData['currentBtn'] = resouce.key;
    this.currentData['projection_keys'] = resouce.key + ',uhId,patient_name,patient_age,patient_gender,patient_telecom';
    // if (this.currentData['navigated'] != undefined && this.currentData['navigated']) {
    // this.currentData['projection_keys'] = resouce.key + ',uhId,patient_name,patient_age,patient_gender,patient_telecom';
    if (this.currentData['navigated'] != undefined && this.currentData['navigated']) {
      this.filterClick(this.currentData['queryParams'].uhId);
    }
    else if (this.currentData != undefined && this.currentData.bannerData != undefined && this.currentData.bannerData.uhId != undefined && this.currentData.bannerData.uhId) {
      this.filterClick(this.currentData.bannerData.uhId);
    }

    // }
  }

  async getData(queryId, args, resource, application, filter, projection_keys, toStoredin, callback?) {
    this.loader.showSpinner();
    let obj = {};
    obj['filter'] = filter;
    if (this.currentData['projection_keys'] != undefined && this.currentData['projection_keys']) {
      obj['projectionKeys'] = this.currentData['projection_keys'];
    }
    await this.baseService.getData(obj, '', resource, application, queryId).toPromise().then(data => {
      if (data && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
        this.currentData[toStoredin] = data.resource;

        if (callback) {
          callback(this.currentData[toStoredin]);
        }
      }
      else if (callback) {
        callback(false);
      }
      this.loader.hideSpinner();
    })
  }


  downloadFile(url: string): any {
    this.baseService.getFileByUrl(url, false).subscribe(result => {
      if (result) {
        this.currentData.imageInfo[0].contentType = result.type;
        this.currentData.type = result.type;
        const blobTest = new Blob([result], { type: result.type });
        this.currentData.currentPrescription = URL.createObjectURL(blobTest);
        this.loader.hideSpinner();
        this.currentData.show = true;
      }
      this.loader.hideSpinner();
    })
    this.loader.showSpinner();

  }

  monthsToMilliseconds(months) {
    // Average number of days in a month
    const daysInMonth = 30.44;

    // Convert months to milliseconds
    const milliseconds = months * daysInMonth * 24 * 60 * 60 * 1000;

    return milliseconds;
  }

  filterClick(event, filter_?) {
    if (event != undefined && event) {
      let filter;
      if (!filter_) {
        filter = 'uhId:' + event;
      }

      if (filter_) {
        filter_ = filter;
      }
      this.getData('GET_PAGE', '', 'patient_journey', 'emr', filter, this.currentData['projection_keys'], 'archiveData', (data) => {
        if (data != undefined && data.length != undefined && data.length > 0) {
          //removing data will be removed
          if (data[0]['diagnostic_reports'] != undefined && data[0]['diagnostic_reports'].length != undefined && data[0]['diagnostic_reports'].length > 0) {
            //sorting on the basis of gcreation time
            try {

              //removing current six months data

              const milliseconds = Date.now();

              const sixmonthsdate = this.monthsToMilliseconds(6);
              const allowedmillis = milliseconds - sixmonthsdate;

              //filtering data for 6 months and isDefinalize
              if (this.currentData['navigated'] != undefined && this.currentData['navigated']) {
                data[0]['diagnostic_reports'] = data[0]['diagnostic_reports'].filter(crntData => (!crntData.isDefinalize) && (crntData.orderDateTime < allowedmillis));
              }
              else {
                data[0]['diagnostic_reports'] = data[0]['diagnostic_reports'].filter(crntData => !crntData.isDefinalize);
              }


              data[0]['diagnostic_reports'] = data[0]['diagnostic_reports'].sort((a, b) => {
                return b.creation_time - a.creation_time;
              });
            } catch (error) { }
          }

          this.currentData.bannerData = data[0];
          if (data[0][this.currentData['currentBtn']] != undefined) {
            this.currentData.list = data[0][this.currentData['currentBtn']];
            this.currentData.clonedList = JSON.parse(JSON.stringify(this.currentData.list));
            if (this.currentData != undefined && this.currentData.list != undefined && this.currentData.list[0] != undefined && this.currentData.list[0]['print_details'] != undefined)
              this.setView(this.currentData.list[0]['print_details'], 0);
          }
          else {
            this.currentData.list = [];
          }
        }
        else {
          this.currentData.selectedList = false;
          this.currentData.list = [];
          this.currentData.bannerData = {};
        }
      })
    }
    else {
      this.currentData.selectedList = false;
      this.currentData.list = [];
      this.currentData.bannerData = {};
    }

  }

  removeClass() {
    let child = this.elementRef.nativeElement.getElementsByClassName('doc-view-list');
    for (let cl of child) {
      cl.classList.remove("doc-active-tab");
    }
  }

  setView(data, i?) {
    this.currentData.dropdownDataVal = i;
    this.currentData.dropdownData = data;
    this.removeClass()
    this.currentData.show = false;
    this.currentData.selectedList = data;
    setTimeout(() => {
      this.setAsideInfo(data[i]);
    });
  }

  setAsideInfo(data) {
    // billing_print/account_id=6ad4e820-ffcc-11e9-a0e6-96e83143993f-37/uhId=SERIES2023-1272/facility_id=47cf7fb0-6f71-11ea-9682-be528eb39f27-15/bill_date=2023-06-22/bill_no=ipb/533/admissionId=BL_12489/ipfinalbillsummary_1687437040294.pdf;
    this.currentData.document_type = data.document_type;

    let url = '/dms/api/v1/' + data.document_type + '/image-response-entity?path=' + data.document_url;
    this.downloadFile(url);
  }

  setViewer(data) {

    this.setFields(data);
    // if (this.currentData.bannerData != undefined && this.currentData['currentBtn'] != undefined && this.currentData.bannerData[this.currentData['currentBtn']] != undefined) {
    //   this.currentData.list = this.currentData.bannerData[this.currentData['currentBtn']];
    //   this.setView(this.currentData.list[0]['print_details'], 0);
    // }
    // else {
    //   this.currentData.selectedList = false;
    //   this.currentData.list = [];

    // }

  }

  setDropdownView(event) {
    this.setView(this.currentData.dropdownData, event.target.value);
  }

  displayFilter() {
    this.currentData.filterBlock.default_open = !this.currentData.filterBlock.default_open;
  }

  doSearch(event) {
    let filter = this.createFilters(event);
    let arr = JSON.parse(JSON.stringify(this.currentData.clonedList));
    for (let key in filter) {
      if (key == 'fromToKey' && filter['FROM'] != undefined && filter['TO'] != undefined && filter['FROM'] != 'null' && filter['TO'] != 'null') {
        let obj = {};
        obj['min'] = parseInt(filter['FROM']);
        obj['max'] = parseInt(filter['TO']);
        arr = this.filterByDynamicRange(arr, filter[key], obj);
      }
      else if (key != 'FROM' && key != 'TO' && key != 'fromToKey') {
        let obj = {};
        obj['equal'] = filter[key];
        arr = this.filterByDynamicRange(arr, key, obj);
      }
    }
    this.currentData.list = arr;

  }

  filterByDynamicRange(arr, property, filterOptions) {
    return arr.filter(item => {
      const { min, max, equal } = filterOptions;
      if (equal !== undefined) {
        return item[property] === equal;
      }
      return (min === undefined || item[property] >= min) && (max === undefined || item[property] <= max);
    });
  }

  createFilters(event) {
    if (event != undefined && event.length != undefined) {
      let arr = event.split(',');
      let obj = {};
      for (let item of arr) {
        let keyVal = item.split(':');

        if (keyVal[0] != undefined && keyVal[1] != undefined) {
          obj[keyVal[0]] = keyVal[1];
        }

      }
      return obj;
    }
  }





}
